import RecorderV2 from './RecorderV2'

export default RecorderV2